import Home from './home'
import AddApply from './addApply'
import ApplyDetail from './applyDetail'
export default {
  Home,
  AddApply,
  ApplyDetail
}
